module.exports = __webpack_public_path__ + "static/img/company.8bda604.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mastheads/company.jpg
// module id = d2oE
// module chunks = 1